<template>
  <div>
    <div>
      <el-dialog title="打印磅单" center :visible="DYBDVisible" width='950px' :close-on-click-modal="false" @close="closeDialog" >
        <div id="printMe" ref="print">
          <div class="printtable" style="page-break-after:always;">
            <div class="table_title">
              入库过磅计量单
            </div>
            <!-- 打印 -->
            <div style="padding-right: 6px;">
              <div class="AMarkUl">
                <ul>
                  <li>时间:{{ datenow }}</li>
                  <li>单号:{{ rowData.instockNo }}</li>
                </ul>
              </div>
              <table style="word-break:break-all;word-wrap:break-all;">
                <tbody>
                  <tr>
                    <td class="kunbao" style="">发货单位</td>
                    <td  style="min-width:75px">{{ziRowData.queueForwardUnit}}</td>
                    <td class="kunbao" style="">毛重</td>
                    <td  style="min-width:75px">{{ziRowData.queueEntryWeighing}} 吨</td>
                  </tr>
                  <tr>
                    <td class="kunbao">收货单位</td>
                    <td  style="min-width:75px">{{rowData.customerName}}</td>
                    <td class="kunbao">皮重</td>
                    <td style="min-width:75px">{{ziRowData.queueExitWeighing}} 吨</td>
                  </tr>
                   <tr>
                    <td class="kunbao" style="">车牌号</td>
                    <td  style="min-width:75px">{{rowData.instockPlateNumber}}</td>
                    <td class="kunbao" style="">净重</td>
                    <td style="min-width:75px">{{ziRowData.weighingWeight}} 吨</td>

                  </tr>
                  <tr>
                     <td class="kunbao">货物名称</td>
                     <td  style="min-width:75px">{{ziRowData.productTypeName}}</td>
                    <td class="kunbao" style="">毛重时间</td>
                    <td  style="min-width:75px">{{ziRowData.queueEntryWeighingTime|dateFormat}}</td>
                  </tr>
                   <tr>
                    <td class="kunbao">原发净重</td>
                    <td  style="min-width:75px">{{ziRowData.factoryWeight}} 吨</td>
                    <td class="kunbao">皮重时间</td>
                    <td  style="min-width:75px">{{ziRowData.queueExitWeighingTime|dateFormat}}</td>
                  </tr>
                   <tr>
                    <td class="kunbao" style="">司磅员</td>
                    <td  style="min-width:75px">{{userName}}</td>
                    <td class="kunbao">备注</td>
                    <td  style="min-width:75px">{{rowData.ext1}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dayinFN">打印</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  billList
} from '@/api/wms-access'
import { dateFormat1 } from '@/utils/util'
export default {
  name: 'djDialog',
  data () {
    return {
      datenow: '',
      userName: window.localStorage.getItem('userName')
    }
  },
  props: {
    DYBDVisible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    ziRowData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  methods: {
    dayinFN () {
      this.$print(this.$refs.print)
    },
    closeDialog () {
      this.$emit('update:DYBDVisible', false)
    }
  },
  mounted () {
    this.datenow = dateFormat1(new Date().getTime(), 'CHN-YYYY-MM-ss h-m-s')
  }
}
</script>

<style scoped lang='less'>
#printMe {
  font-size: 16px;
  position: relative;
  padding: 10px;
  // margin-bottom: 10px;
  box-sizing: border-box;
  //   height: 500px;
  width: 100%;

  .table_title {
    width: 100%;
    height: 40px;
    font-size: 26px;
    text-align: center;
    font-weight: 700;
    margin: 10 0;
  }
}
.printtable {
  width: 900px;
  margin-bottom: 20px;
  box-sizing: border-box;
}
.AMarkUl {
  // font-size: 12px !important;
  width: 100%;
  font-size: 14px;
  ul {
    width: 100%;
    display: flex;
    justify-content: space-between;
    li {
      list-style: none;
      // flex: 1;
      // color: black;
    }
  }
}
.AMarkFoot {
  font-size: 14px;
  bottom: 10px;
  width: 100%;
  ul {
    width: 100%;
    display: flex;
    margin: 10 !important;
    padding: 0 !important;
    justify-content: space-between;
    li {
      list-style: none;
      // flex: 1;
      // color: black;
    }
  }
}
table,
th,
td {
  border: 1px solid blue;
}
table {
  border-collapse: collapse;
}

table,
th,
td {
  border: 1px solid black;
}
table {
  width: 100%;
  margin: 0 auto;
  margin-bottom: 10px;
  font-size: 16px;
  td {
    // width: 17%;
    // padding: 4px 4px;
    text-align: center;
    height: 24px;
  }

  .kunbao {
    font-weight: 600;
  }
}

</style>
